import { IUnidEntityAddRequest } from '../../../../model/scp/entity/request/unid-entity-add-request';
import { ValidationErrors, isBlank } from '../../../../utils/validation';

export type UnidEntityField = 'unitCode' | 'name' | 'ibgeCode';

export function validateUnidEntity(request: Partial<IUnidEntityAddRequest>): ValidationErrors<UnidEntityField> {
    const errors: ValidationErrors<UnidEntityField> = {};
    if (isBlank(request.unitCode)) errors.unitCode = 'Código da unidade é obrigatório';
    if (isBlank(request.name)) errors.name = 'Nome é obrigatório';
    if (isBlank(request.ibgeCode)) errors.ibgeCode = 'Código IBGE é obrigatório';
    return errors;
}
